/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/CartSavedItems',[
    'jquery',
    'lodash',
    './CartManager',
    './CartLocker',  //customization: locking cart when ordering approved quotes
    'global/all',
    'modules/Product/ProductUnitsOfMeasureHelper'
], function ($, _, CartManager, CartLocker, Roc, UnitOfMeasureHelper) {
    'use strict';

    var savedItemsSelector = '#cartSavedItems';
    var itemWrapperSelector = '[data-roc-item-wrapper]';

    var viewModel = {};
    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var btns = {
        moveSavedItemToCart: '[data-roc-action="moveSavedItemToCart"]',
        removeSavedItem: '[data-roc-action="removeSavedItem"]'
    };


    function getItemData(element, attr) {
        return $(element).parents(itemWrapperSelector).attr('data-' + attr);
    }

    function checkEmptyResultsDisplay() {
        if ($(savedItemsSelector + ' ' + itemWrapperSelector).length > 0) {
            $(savedItemsSelector).show();
        } else {
            $(savedItemsSelector).hide();
        }
    }

    function bindViewModel() {
        _.each(viewModel.savedItems,
            function (savedItem) {
                // customization, get Uom details from product pricing which is correct in this case
                if (savedItem.product !== undefined &&
                    savedItem.product !== null &&
                    savedItem.product.productPricing !== undefined &&
                    savedItem.product.productPricing !== null) {

                    var isQuoteOnly = !savedItem.product.productPricing.loadPricingResponse.responseCode ||
                        savedItem.product.productPricing.loadPricingResponse.responseCode !== 'Success' ||
                        savedItem.product.isQuoteOnly;
                    savedItem.unitOfMeasure = savedItem.product.productPricing.unitOfMeasure;
                    savedItem.isQuoteOnly = isQuoteOnly;
                    savedItem.hasUnitOflength = savedItem.product.availableUnitsOfMeasure[0] &&
                        UnitOfMeasureHelper.isUnitOfLength(savedItem.product.availableUnitsOfMeasure[0]);
                }
                //savedItem.unitOfMeasure = _.find(savedItem.product.availableUnitsOfMeasure, { id: savedItem.uomId });
            });

        Roc.UI.template('savedItems-Tmp', viewModel).then(function (renderedTemplate) {
            $(savedItemsSelector + ' .content').html(renderedTemplate);
            checkEmptyResultsDisplay();
        });
    }

    function reload() {
        var url = apiUrl + '/api/store/cart/saveditems/';
        $.getJSON(
            url,
            function (data) {
                Roc.Logger.info('CartManager -> reload');
                Roc.Logger.info(data);
                viewModel.savedItems = data;
                bindViewModel();
            });
    };

    /* Events */
    function moveSavedItemTCartEvt() {
        $(document).on('click', btns.moveSavedItemToCart, function (e) {
            var savedItemId = getItemData(this, 'saved-item-id');
            /* customization: locking cart when ordering approved quotes */
            /* check if cart is not locked before action */
            CartLocker.isCartUnlocked()
                .then(function () {
                    CartManager.moveSavedItemToCart(e, savedItemId);
                });
        });
    };

    function removeSavedItemEvt() {
        $(document).on('click', btns.removeSavedItem, function () {
            var savedItemId = getItemData(this, 'saved-item-id');
            CartManager.removeSavedItem(savedItemId);
        });
    }

    function hideItem(response) {
        if (response && response.success === true) {
            var $savedItemsList = $(savedItemsSelector);
            var itemsCount = $savedItemsList.find(itemWrapperSelector).length;
            if (itemsCount <= 1) {
                $savedItemsList.find(itemWrapperSelector).remove();
                $savedItemsList.slideUp();
                checkEmptyResultsDisplay();
            } else {
                $(savedItemsSelector).find(itemWrapperSelector + '[data-saved-item-id="' + response.savedItemId + '"]').slideUp().remove();
            }
        }
    };

    function updateAfterSave(response) {
        if (response.success === true) {
            reload();
        }
    };

    function bindEvents() {
        removeSavedItemEvt();
        moveSavedItemTCartEvt();
        Roc.EventManager.bind(Roc.Events.cart.MOVE_SAVED_ITEM, hideItem);
        Roc.EventManager.bind(Roc.Events.cart.SAVE_ITEM, updateAfterSave);
        Roc.EventManager.bind(Roc.Events.cart.REMOVE_SAVED_ITEM, hideItem);
    };

    function init(options) {
        viewModel = options;
        bindViewModel();
        bindEvents();
    };

    var CartSavedItems = {
        init: init,
        updateAfterSave: updateAfterSave,
        hideItem: hideItem
    };

    Roc.Logger.debug('CartSavedItems.js Loaded:', CartSavedItems);

    return CartSavedItems;
});

